var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","color":"gridItemBackground"}},[_c('div',{staticClass:"ml-2 mt-2",domProps:{"innerHTML":_vm._s(_vm.modemInfo)}})])}
var staticRenderFns = []

export { render, staticRenderFns }